module.exports = __webpack_public_path__ + "img/detencionExcesiva.c8a2505d.svg";